module.exports = __webpack_public_path__ + "media/assets/images/flags/gw-63c2421a1b3c9a109f7f7a73c2a096cd.svg";